export const ukVN = {
  app: {
    categories: {
      convectors: 'Конвектори',
      decorative: 'Декоративні',
      electric: 'Електричні',
      panels: 'Панельні',
      towel: 'Рушникосушки',
    },
    categoryLabel: 'Категорія',
    categoryPlaceholder: 'Оберіть категорію',
    errorCategories: 'Не вдалося завантажити категорії.',
    errorPanels: 'Не вдалося завантажити радіатори.',
    loadingCategories: 'Завантаження категорій...',
    loadingPanels: 'Завантаження радіаторів...',
    panelLabel: 'Радіатори',
    panelPlaceholder: 'Оберіть радіатор',
    titles: {
      convectors: 'Калькулятор конвекторів',
      decorative: 'Калькулятор дизайнерських радіаторів',
      electric: 'Калькулятор електричних радіаторів',
      panels: 'Калькулятор панельних радіаторів',
      towel: 'Калькулятор рушникосушок',
    },
  },
  calc: {
    actionButton: 'Показати розраховані позиції',
    boost: 'Режим підсилення',
    calculateRequiredButton: 'Розрахувати необхідну потужність',
    calculating: 'Розрахунок...',
    comfort: 'Комфортний режим',
    downloadLabel: 'Завантажити дані ({count})',
    emptyResults: 'Ще немає результатів.',
    errorMatch: 'Не вдалося розрахувати результати.',
    errorTypes: 'Не вдалося завантажити типи радіаторів.',
    flowTemp: 'Температура подачі C°',
    height: 'Висота',
    length: 'Довжина',
    loadingTypes: 'Завантаження типів...',
    modeLabel: 'Режим',
    modes: {
      cooling: 'Охолодження',
      heating: 'Опалення',
    },
    radiatorType: 'Тип радіатора',
    requiredWatts: 'Необхідна потужність (Вт)',
    resultsMessage: '{count} позицій доступно для обраних параметрів.',
    returnTemp: 'Температура зворотна C°',
    roomTemp: 'Температура в приміщенні C°',
    selectAllLabel: 'Обрати всі позиції',
    selectItemLabel: 'Оберіть позицію для завантаження',
    selectPanel: 'Оберіть радіатор для розрахунку.',
    standby: 'Режим очікування',
    tableHeaders: {
      calculatedWattage: 'Ват',
      co2Equivalent: 'Еквівалент CO2 на кг матеріалу',
      depth: 'Ширина [мм]',
      description: 'Опис позиції',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Висота [мм]',
      itemId: 'Код позиції',
      length: 'Довжина [мм]',
      waterContent: 'Вміст води',
      weight: 'Вага',
    },
    title: 'Розрахунки',
    tolerance: 'Допустимо',
    typeCooling: 'Охолодження',
    typeGroupLabel: 'Тип',
    typeHeating: 'Опалення',
  },
  existingRadiator: {
    description:
      'Цей калькулятор має лише інформативне призначення. Перед покупкою радіатора завжди консультуйтеся з професійним монтажником щодо точного розрахунку.',
    height: 'Висота радіатора',
    length: 'Довжина радіатора',
    resultLabelTemplate: 'Необхідна теплова потужність, розрахована при температурі системи {temp}',
    select: 'Обрати',
    temperature: 'Температура системи',
    type: 'Тип радіатора',
  },
  matrixCalc: {
    axisHeight: 'Висота (мм)',
    axisLength: 'Довжина (мм)',
    axisType: 'Тип',
    calculateButton: 'Calculate',
    displayLabel: 'Відображення',
    exportExcel: 'Експорт в Excel',
    exportPdf: 'Експорт у PDF',
    print: 'Друк',
    hideOutOfRange: 'Приховати позиції поза діапазоном',
    showAll: 'Показати все',
    loading: 'Loading...',
    lockHeight: 'Висота',
    lockLabel: 'Зафіксувати розмір',
    lockLength: 'Довжина',
    lockType: 'Тип',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Розрахувати',
    clearButton: 'Очистити все',
    fields: {
      ceilingHeight: 'Висота стелі',
      doorInsulation: 'Теплоізоляція дверей',
      floorInsulation: 'Теплоізоляція підлоги',
      glazingArea: 'Площа скління',
      glazingMode: 'Площа скління',
      glazingQuality: 'Якість скління',
      length: 'Довжина',
      outerWalls: 'Зовнішні стіни',
      projectedDesignTemp:
        'Розрахункова температура повітря зовні (РТЗ) для місця розташування будівлі',
      roofInsulation: 'Теплоізоляція даху',
      roomArea: 'Площа приміщення',
      roomFloor: 'Поверх',
      roomInsulation: 'Теплоізоляція приміщення',
      roomPreset: 'Призначення приміщення',
      roomTemperature: 'Температура приміщення',
      roomType: 'Тип приміщення',
      uncertaintyFactor: 'Коефіцієнт невизначеності',
      ventilation: 'Рівень вентиляції',
      wallInsulation: 'Теплоізоляція стін',
      width: 'Ширина',
      windConditions: 'Вітрові умови',
      windowInsulation: 'Теплоізоляція вікон',
    },
    intro:
      'Розрахуйте тепловтрати приміщення, щоб обрати правильний продукт із нашого асортименту радіаторів.',
    options: {
      glazing: {
        m2: 'м²',
        percent: '%',
      },
      glazingBands: {
        high: 'Більше 20%',
        low: 'Менше 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Понад 20%',
        below_10: 'Менше 10%',
        from_10_to_20: 'Від 10% до 20%',
        no_windows: 'Без вікон',
      },
      insulationValue: {
        good: 'Гарна',
        medium: 'Середня',
        poor: 'Слабка',
        very_good: 'Дуже гарна',
      },
      qualityValue: {
        modern_excellent: 'Сучасні, відмінна енергоефективність',
        modern_good: 'Сучасні, гарна енергоефективність',
        old_poor: 'Старі, дуже погана енергоефективність',
        traditional_medium: 'Традиційні, середня енергоефективність',
      },
      roomValue: {
        bathroom_24: 'Ванна кімната (24 C°)',
        bedroom_20: 'Спальня (20 C°)',
        garage_12: 'Гараж (12 C°)',
        livingroom_22: 'Вітальня (22 C°)',
        storage_16: 'Комора (16 C°)',
      },
      select: 'Обрати',
      storeyValue: {
        ground_multi: 'Перший поверх (багатоповерхова будівля)',
        ground_single: 'Перший поверх (одноповерхова будівля)',
        interim: 'Середній поверх',
        top_multi: 'Верхній поверх (багатоповерхова будівля)',
      },
      temp: {
        climate_zone_1: 'РТЗ -12 C°',
        climate_zone_2: 'РТЗ -14 C°',
        climate_zone_3: 'РТЗ -16 C°',
        climate_zone_4: 'РТЗ -18 C°',
        climate_zone_5: 'РТЗ -20 C°',
        climate_zone_6: 'РТЗ -22 C°',
        climate_zone_7: 'РТЗ -24 C°',
        climate_zone_8: 'РТЗ -26 C°',
      },
      windInfluence: {
        normal: 'Нормальні',
        strong: 'Несприятливі',
        weak: 'Сприятливі',
      },
    },
    roomPresets: {
      bathroom: 'Ванна кімната',
      bedroom: 'Спальня',
      garage: 'Гараж',
      kitchen: 'Кухня',
      living: 'Вітальня',
      storage: 'Комора',
    },
    sections: {
      dimensions: 'Розміри приміщення',
      insulation: 'Теплоізоляція',
      placement: 'Розміщення',
      result: 'Результат',
      temps: 'Температури',
      ventilation: 'Вентиляція',
    },
    title: 'Калькулятор тепловтрат',
    units: {
      celsius: 'C°',
      meter: 'м',
      percent: '%',
      squareMeter: 'м²',
      watts: 'Вт',
    },
    useButton: 'Використати',
  },
  slider: {
    from: 'Від',
    to: 'До',
    value: 'Значення',
  },
}
